export default __webpack_public_path__ + "static/media/ReportIcon-Vascular-MS.22764b08.jpg";